import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Col } from '@/components/Col';
import { Flex } from '@/components/Flex';

export const GalleryWrapperCol = styled(Col)`
  position: relative;

  ${({ theme }) => css`
    ${theme.media.md.only} {
      grid-column: span 7;
    }

    ${theme.media.md.down} {
      background: ${`linear-gradient(${theme.colors.lightGrey}, ${theme.colors.tertiaryGrey})`};
    }
  `}
`;

export const GalleryIcons = styled(Flex)`
  position: absolute;
  top: 0;
  margin-top: 10px;
  width: calc(100% - ${({ theme }) => theme.spacing(0.25)});
  justify-content: space-between;
  align-items: flex-end;

  ${({ theme }) => theme.media.md.up} {
    width: 100%;
    align-items: flex-start;
  }

  .share-wrapper > svg {
    transform: translateX(2px);
  }

  svg {
    width: 26px;
    height: 26px;
    box-sizing: content-box;
    pointer-events: all;
    position: static;
    z-index: ${({ theme }) => theme.zIndex.navigation};
    padding: ${({ theme }) => theme.spacing(1, 2)};
    translate: 2;

    :hover {
      cursor: pointer;

      path {
        fill: ${({ theme }) => theme.colors.primary};
      }
    }

    path {
      transition: ${({ theme }) => theme.transitions.create('fill')};
      fill: ${({ theme }) => theme.colors.secondaryGrey};
    }
  }
`;

export const LabelWrapper = styled(Box)`
  margin: ${({ theme }) => theme.spacing(1, 3)};
  z-index: 2;
`;

export const ActionsWrapper = styled(Flex)`
  ${({ theme }) => css`
    z-index: 2;
    ${theme.media.md.down} {
      transform: translateY(50%);
    }
  `}
  && button {
    position: static;
    padding: 0;
  }
`;

export const CenterLoader = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  z-index: 1;
`;
